var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundedDarkAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.461 8.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.466,27.263H26.25V14.25h1.216Z",
    transform: "translate(-14.954 -7.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.466,25.341H17.25V5.25h1.216Z",
    transform: "translate(-11.602 -5.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.466,28.544H8.25V20.25H9.466Z",
    transform: "translate(-8.25 -8.454)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedDarkAnalytics);
export default __webpack_public_path__ + "static/media/icon_rounded_dark_analytics.5b652f9d8c056c8eca2d215a84bfac01.svg";
export { ForwardRef as ReactComponent };